import React, { useState, useEffect, useRef } from "react";
import Script from "next/script";
import { useRouter } from "next/router";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import store from "store";
import { Hooks } from "@xt/xtbase";
const {useIntl,FormattedMessage} = Hooks;
import useIsDesktop from "@/hooks/useIsDesktop";
import AuthShell from "@/components/AuthShell";
import { IconMail } from "@/components/AuthShell/brandIcons";
import stylesLess from "./index.module.less";
import axios from "utils/axios";
import sessionStorage from "utils/sessionStorage";
import cookie from "utils/cookie";
import LocalStorage from "utils/localStorage";
import { getAbsoluteUrl } from "utils/method";
import { GOOGLE_CLIENT_ID, GSI_SCRIPT_SRC } from "utils/googleGsi";
import { APPLE_CLIENT_ID, APPLE_SCRIPT_SRC, getAppleRedirectUri, getAppleInitConfig } from "utils/appleAuth";
import {
  regexp,
  doRsaEncrypt,
  getExplore,
  browserRedirect,
  getUUID,
  redirectToHome,
} from "utils/method";
import {
  post_loginByFaBeforeCheck,
  post_subAccountloginByFaBeforeCheck,
  post_passwdPublicKey,
  get_qr,
  get_qrResult,
  post_authorizeGoogleToken,
  post_authorizeAppleToken,
} from "api/uaapi/uaa";
import { put_publicKey, put_authorizeFaBeforeCheck, post_authorizeFa } from "api/uaapi/account";
import { get_faCheckToken } from "api/uaapi/user";
import { get_subAccountloginBy2Fa } from "api/uaapi/uaa";

import { loginSuccessAndSkip, handleThirdLoginResponse, MOCK_GOOGLE_TOKEN_SCENARIO, getMockGoogleTokenResponse } from "components/Pages/Login/loginUtils";

import { message } from "antd";
import AntdModalAlert from "components/Antd/Modal/Alert";
import ButtonBig from "components/Antd/Button/big";
import FormItem from "components/App/FormItem";
import FormItemInput from "components/App/FormItem/Input";
import FormItemPassword from "components/App/FormItem/Password";
import CountryList from "components/App/Country";
import Geetest from "components/Geetest";
import CaptchaDemo from "components/Pages/Login/CaptchaDemo";
import QRCode from "qrcode.react";

import imgLogo_dark from "assets/images/sao-dark.svg";
import imgLogo_light from "assets/images/sao-light.svg";
// import logo from "../../../../public/logo.png";
import correct from "assets/images/correct.svg";
import iconGoogle from "assets/images/register/google.svg";
import iconAppleDark from "assets/images/register/apple-dark.svg";
import iconAppleLight from "assets/images/register/apple-light.svg";

import jsrsasign, { KEYUTIL, KJUR, RSAKey } from "jsrsasign";
import { trackRegisterEntryClick, PAGE_KEYS, ENTRIES } from "@/utils/clientBehavior";

export default observer(function Register() {
  const intl = useIntl();
  const router = useRouter();
  const {isDark} = store.app;
  const { isDesktop, isReady } = useIsDesktop();
  const isSpikexPc = isReady && isDesktop;

  const [state_type, setState_type] = useState();
  const [qrUrl, setQrUrl] = useState("");
  const [publicKey, setPublicKey] = useState("");
  const [privateKey, setPrivateKey] = useState("");
  const [sign, setSign] = useState(Date.now());
  const [qrKey, setQrKey] = useState("");
  const [status, setStatus] = useState("NEW");
  const imgLogo = isDark ? imgLogo_dark : imgLogo_light;

  const getQrResult = async () => {
    if (!qrKey || !privateKey) return;
    console.log("qrKey:", qrKey);
    console.log("privateKey:", privateKey);
    const timestamp = Date.now();
    console.log(
      "timestamp=${timestamp}&qrKey=${qrKey}",
      `timestamp=${timestamp}&qrKey=${qrKey}`
    );
    const appSecret =
      "-----BEGIN PRIVATE KEY-----" + privateKey + "-----END PRIVATE KEY-----";
    let rsa = new RSAKey();
    try {
      rsa = KEYUTIL.getKey(appSecret);
    } catch (e) {
      console.warn("[QR login] invalid private key, skip poll", e);
      return;
    }
    // 创建Signature对象，设置签名编码算法
    let sig = new KJUR.crypto.Signature({ alg: "SHA1withRSA" });
    // 初始化
    sig.init(rsa);
    // 传入待加密字符串
    sig.updateString(`timestamp=${timestamp}&qrKey=${qrKey}`);
    // 生成密文
    let sign = jsrsasign.hextob64(sig.sign());
    // 对加密后内容进行URI编码
    // let sign1 = encodeURIComponent(sign);
    console.log("验签：", sign);
    let deviceId = "";
    if (LocalStorage.get("client-device-id")) {
      deviceId = LocalStorage.get("client-device-id");
    } else {
      deviceId = getUUID();
      LocalStorage.set("client-device-id", deviceId);
    }
    LocalStorage.get("client-device-id");
    const deviceIdPublicKey = await axios.asyncAwait(post_passwdPublicKey, {
      errorPop: true,
    });
    try {
      const result = await get_qrResult({
        headers: {
          "client-device-id": doRsaEncrypt(
            deviceIdPublicKey.data.publicKey,
            deviceId
          ),
          "client-device-name": `${getExplore()} (${browserRedirect()})`,
        },
        params: {
          qrKey,
          timestamp,
          sign,
          passwdId: deviceIdPublicKey.data.passwdId,
        },
      });
      console.log("get_qrResult", result);
      if (!result) {
        setStatus("NEW");
        return;
      }
      if (result.loginStatus === 7) {
        setStatus("scanSuccess");
        return;
      }
      if (result.loginStatus === 1) {
        //登录成功
        sessionStorage.set("token", result.accessToken);
        cookie.set("token", result.accessToken);
        stopTimer();
        try {
          sensors.login(data.userVO.userId);
        } catch (e) {
          //
        }

        if (
          result.userVO &&
          !result.userVO.regCountryId &&
          !result.userVO.kycAuthCountryId
        ) {
          if (typeof location !== "undefined")
            location.replace(
              getAbsoluteUrl({
                pathname: "/country",
                locale: router.locale,
                query: router.query,
              })
            );
          else
            router.replace({
              pathname: "/country",
              query: router.query,
            });
        } else {
          redirectToHome(router);
          // redirectBackUrl(router); // 原逻辑：按 backurl 跳转，需恢复时可改回
        }
      }
    } catch (error) {
      if (error.code == 921) {
        setStatus("EXPIRED");
        stopTimer();
      }
      console.log("error!!!!", error);
    }
  };

  let timer = React.useRef();

  useEffect(() => {
    sessionStorage.remove("puzzleValidateString");
  }, []);

  useEffect(() => {
    // QR UI currently unused; only poll after a real qrKey + privateKey exist
    if (!qrKey || !privateKey) {
      stopTimer();
      return undefined;
    }
    startTimer();
    return () => {
      stopTimer();
    };
  }, [qrKey, privateKey]);

  // useEffect(()=>{
  //   if(status == "EXPIRED") {
  //     stopTimer()
  //   }
  // }, [status])

  // 开启定时器
  const startTimer = () => {
    console.log("开启定时器!!!!!");
    stopTimer();
    timer.current = setInterval(() => {
      getQrResult();
    }, 5000);
  };

  // 关闭
  const stopTimer = () => {
    console.log("关闭定时器!!!!!");
    clearInterval(timer.current);
  };

  const getQrCode = async () => {
    try {
      const result = await get_qr({
        headers: {
          "client-device-name": `${getExplore()} (${browserRedirect()})`,
        },
      });
      console.log("result:", result);
      setQrKey(result.qrKey);
      let privateDer = result.privateKey;
      privateDer = privateDer.replace(/\n/g, "");
      privateDer = privateDer.replace("-----BEGIN RSA PRIVATE KEY-----", "");
      privateDer = privateDer.replace("-----END RSA PRIVATE KEY-----", "");
      setPrivateKey(privateDer);
      console.log("qrUrl:", `${result.qrKey}&qrLogin`);
      setQrUrl(`${result.qrKey}&qrLogin`);
      setStatus("NEW");
    } catch (error) {
      //error
    }
  };

  useEffect(() => {
    try {
      sensors.track("LoginPage", {
        from_page: router.query.backurl || "",
      });
    } catch (error) {}
    // create_key();
  }, []);

  const create_key = () => {
    getQrCode();
  };

  useEffect(() => {
    if (state_type) {
      LocalStorage.set("loginType", state_type);
    } else {
      let loginType = LocalStorage.get("loginType");
      // loginType = /^(email|mobile|subAccount)$/.test(loginType) ? loginType : "email";
      loginType = /^(email|mobile)$/.test(loginType) ? loginType : "email";
      setState_type(loginType);
    }
    console.log("useEffect state_type", state_type);
    setState_email("");
    setState_mobile("");
    setUserName("");
    setState_password("");
  }, [state_type]);

  const [state_email, setState_email] = useState("");
  const [state_email_status, setState_email_status] = useState({
    isOK: false,
    errMsg: "",
  });
  const verify_email = (bool) => {
    const newVal = state_email;
    const errMsg = intl.formatMessage({ id: "register.plsInputCorrectEmail" });
    let status = { isOK: true, errMsg: "" };
    if (!newVal) {
      status = { isOK: false, errMsg: bool ? errMsg : "" };
    } else if (!regexp("email", newVal)) {
      status = {
        isOK: false,
        errMsg: errMsg,
      };
    }

    setState_email_status(status);
    return status;
  };
  useEffect(() => {
    // verify_email();
    setState_email_status({ isOK: false, errMsg: "" });
  }, [state_email]);

  const [state_countryCode, setState_countryCode] = useState("91");
  const [state_mobile, setState_mobile] = useState("");
  const handleInputMobile = (val) => {
    if (/^[0-9]*$/.test(val)) setState_mobile(val);
  };
  const [state_mobile_status, setState_mobile_status] = useState({
    isOK: false,
    errMsg: "",
  });
  const verify_mobile = (bool) => {
    const newVal = state_mobile;
    const errMsg = intl.formatMessage({ id: "register.plsInputCorrectPhone" });
    let status = { isOK: true, errMsg: "" };
    if (!newVal) {
      status = { isOK: false, errMsg: bool ? errMsg : "" };
    } else if (!regexp("phone", newVal)) {
      status = {
        isOK: false,
        errMsg: intl.formatMessage({ id: "register.plsInputCorrectPhone" }),
      };
    }

    setState_mobile_status(status);
    return status;
  };
  useEffect(() => {
    // verify_mobile();
    setState_mobile_status({ isOK: false, errMsg: "" });
  }, [state_mobile]);

  const [userName, setUserName] = useState("");
  const [userNameStatus, setUserNameStatus] = useState({
    isOK: false,
    errMsg: "",
  });

  const verifyUserName = (bool) => {
    let status = { isOK: true, errMsg: "" };
    const errMsg = intl.formatMessage({
      id: "register.plsInputCorrectAccount",
    });
    if (!userName) {
      status = {
        isOK: false,
        errMsg: bool ? errMsg : "",
      };
    } else if (!/^.{6,30}$/.test(userName)) {
      status = {
        isOK: false,
        errMsg,
      };
    }
    setUserNameStatus(status);
    return status;
  };

  useEffect(() => {
    setUserNameStatus({ isOK: false, errMsg: "" });
  }, [userName]);

  const [state_password, setState_password] = useState("");
  const [state_password_status, setState_password_status] = useState({
    isOK: false,
    errMsg: "",
  });
  const verify_password = (bool) => {
    const newVal = state_password;
    const errMsg = intl.formatMessage({ id: "register.plsInputPwd" });
    let status = { isOK: true, errMsg: "" };
    if (!newVal) {
      status = { isOK: false, errMsg: bool ? errMsg : "" };
    }

    setState_password_status(status);
    return status;
  };
  useEffect(() => {
    // verify_password();
    setState_password_status({ isOK: false, errMsg: "" });
  }, [state_password]);

  const [state_loading, setState_loading] = useState(false);
  const [gsiReady, setGsiReady] = useState(false);
  const [appleAuthReady, setAppleAuthReady] = useState(false);
  const googleButtonRef = useRef(null);
  const appleButtonContainerRef = useRef(null);

  // 处理 Google 登录成功回调
  const handleCredentialResponse = React.useCallback(async (response) => {
    if (!response?.credential) {
      message.error(intl.formatMessage({ id: "register.googleLoginFailed" }) ?? "Google login failed");
      return;
    }

    try {
      // Mock：不调真实接口，用本地 mock 测试三种场景（MOCK_GOOGLE_TOKEN_SCENARIO: 1=关联账号 2=设置密码 3=直接登录，0=真实接口）
      if (MOCK_GOOGLE_TOKEN_SCENARIO) {
        const data = getMockGoogleTokenResponse(MOCK_GOOGLE_TOKEN_SCENARIO);
        if (data) {
          handleThirdLoginResponse(data, router, response.credential, "google");
          return;
        }
      }

      const { err, data: res } = await axios.asyncAwait(post_authorizeGoogleToken, {
        data: { idToken: response.credential },
        errorPop: false,
      });

      // 调试：三方登录接口原始返回
      console.log("[Google 登录] 接口原始返回 res =", res);
      console.log("[Google 登录] 接口 err =", err);

      if (err || !res) {
        message.error(res?.mc ?? res?.message ?? err ?? intl.formatMessage({ id: "register.googleLoginFailed" }) ?? "Google login failed");
        return;
      }

      const data = res?.result ?? res?.data ?? res;
      // 调试：解析后的 data 及关键字段（用于判断是否走 bind-third）
      console.log("[Google 登录] 解析后 data =", data);
      console.log("[Google 登录] 关键字段 needBindThird =", data?.needBindThird, ", loginStatus =", data?.loginStatus, ", accessToken 有无 =", !!data?.accessToken, ", needSetPassword =", data?.needSetPassword);

      handleThirdLoginResponse(data, router, response.credential, "google");
      if (!data?.accessToken && !data?.needBindThird) {
        message.error(res?.mc ?? res?.message ?? "Login failed");
      }
    } catch (error) {
      console.error("Google 登录处理失败", error);
      message.error(intl.formatMessage({ id: "register.googleLoginFailed" }) ?? "Google login failed");
    }
  }, [router, intl]);

  // 初始化 Google Identity Services 并渲染隐藏按钮
  useEffect(() => {
    if (!gsiReady || typeof window === "undefined" || !window.google?.accounts?.id) return;
    if (!googleButtonRef.current) return;

    // 初始化 GSI
    window.google.accounts.id.initialize({
      client_id: GOOGLE_CLIENT_ID,
      callback: handleCredentialResponse,
    });

    // 渲染按钮到隐藏容器（用于触发登录功能）
    window.google.accounts.id.renderButton(googleButtonRef.current, {
      type: "standard",
      theme: isDark ? "filled_black" : "outline",
      size: "large",
      text: "signin_with",
      shape: "rectangular",
      logo_alignment: "left",
    });
  }, [gsiReady, handleCredentialResponse, isDark]);

  // // Google 登录按钮点击处理 - 触发隐藏的 GSI 按钮
  // const handleGoogleLoginClick = React.useCallback((e) => {
  //   if (state_loading) return;
  //   e.preventDefault();
  //   e.stopPropagation();
    
  //   // 查找并触发隐藏的 GSI 按钮
  //   if (googleButtonRef.current) {
  //     // GSI 按钮通常渲染为 iframe 或包含 iframe 的 div
  //     const container = googleButtonRef.current;
  //     const iframe = container.querySelector('iframe');
  //     const buttonDiv = container.querySelector('div[role="button"]');
      
  //     if (iframe) {
  //       // 方法1: 尝试直接点击 iframe
  //       try {
  //         iframe.click();
  //       } catch (err) {
  //         // 方法2: 尝试通过坐标模拟点击
  //         const rect = iframe.getBoundingClientRect();
  //         const clickEvent = new MouseEvent('click', {
  //           bubbles: true,
  //           cancelable: true,
  //           view: window,
  //           clientX: rect.left + rect.width / 2,
  //           clientY: rect.top + rect.height / 2,
  //         });
  //         iframe.dispatchEvent(clickEvent);
          
  //         // 方法3: 尝试访问 iframe 内部（可能因跨域失败）
  //         try {
  //           const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
  //           if (iframeDoc) {
  //             const clickable = iframeDoc.querySelector('div[role="button"]') || iframeDoc.body;
  //             if (clickable) {
  //               clickable.click();
  //             }
  //           }
  //         } catch (crossOriginErr) {
  //           // 跨域限制，使用备用方案
  //           if (typeof window !== "undefined" && window.google?.accounts?.id?.prompt) {
  //             window.google.accounts.id.prompt();
  //           }
  //         }
  //       }
  //     } else if (buttonDiv) {
  //       // 如果不是 iframe，直接点击 div
  //       buttonDiv.click();
  //     } else {
  //       // 备用方案：使用 prompt
  //       if (typeof window !== "undefined" && window.google?.accounts?.id?.prompt) {
  //         window.google.accounts.id.prompt();
  //       } else {
  //         message.error(intl.formatMessage({ id: "register.googleLoginFailed" }) ?? "Google login failed");
  //       }
  //     }
  //   } else {
  //     // 如果按钮还没渲染，使用 prompt
  //     if (typeof window !== "undefined" && window.google?.accounts?.id?.prompt) {
  //       window.google.accounts.id.prompt();
  //     } else {
  //       message.error(intl.formatMessage({ id: "register.googleLoginFailed" }) ?? "Google login failed");
  //     }
  //   }
  // }, [state_loading, intl]);

  // 处理 Apple 登录成功：与 Google 一致，调后端后走 handleThirdLoginResponse
  const handleAppleToken = React.useCallback(
    async (idToken) => {
      if (!idToken) {
        message.error(intl.formatMessage({ id: "register.appleLoginFailed" }) ?? "Apple login failed");
        return;
      }
      try {
        const { err, data: res } = await axios.asyncAwait(post_authorizeAppleToken, {
          data: { idToken },
          errorPop: false,
        });
        if (err || !res) {
          message.error(res?.mc ?? res?.message ?? err ?? intl.formatMessage({ id: "register.appleLoginFailed" }) ?? "Apple login failed");
          return;
        }
        const data = res?.result ?? res?.data ?? res;
        handleThirdLoginResponse(data, router, idToken, "apple");
        if (!data?.accessToken && !data?.needBindThird) {
          message.error(res?.mc ?? res?.message ?? "Login failed");
        }
      } catch (error) {
        console.error("Apple 登录处理失败", error);
        message.error(intl.formatMessage({ id: "register.appleLoginFailed" }) ?? "Apple login failed");
      }
    },
    [router, intl]
  );

  // 初始化 Apple Sign In 并监听成功/失败（必须传 redirectURI，与 demo 一致）
  useEffect(() => {
    if (!appleAuthReady || typeof window === "undefined" || !window.AppleID?.auth) return;
    const initConfig = getAppleInitConfig();
    console.log("[Apple Sign In] init 传参:", initConfig);
    if (!initConfig.redirectURI) {
      console.warn("[Apple Sign In] redirectURI 为空，未调用 init。请配置 NEXT_PUBLIC_APPLE_REDIRECT_URI 或确保当前页 origin 可用。");
      return;
    }
    try {
      window.AppleID.auth.init({
        clientId: initConfig.clientId,
        scope: initConfig.scope,
        redirectURI: initConfig.redirectURI,
        usePopup: initConfig.usePopup,
      });
    } catch (e) {
      console.warn("Apple Sign In 初始化失败:", e);
    }
    const onSuccess = (event) => {
      const idToken = event.detail?.authorization?.id_token;
      if (idToken) handleAppleToken(idToken);
      else message.error(intl.formatMessage({ id: "register.appleLoginFailed" }) ?? "Apple login failed");
    };
    const onFailure = (event) => {
      const err = event.detail?.error;
      if (err !== "popup_closed_by_user") {
        message.error(intl.formatMessage({ id: "register.appleLoginFailed" }) ?? "Apple login failed");
      }
    };
    document.addEventListener("AppleIDSignInOnSuccess", onSuccess);
    document.addEventListener("AppleIDSignInOnFailure", onFailure);
    return () => {
      document.removeEventListener("AppleIDSignInOnSuccess", onSuccess);
      document.removeEventListener("AppleIDSignInOnFailure", onFailure);
    };
  }, [appleAuthReady, handleAppleToken, intl]);

  // 点击自定义 Apple 按钮时触发 SDK 渲染的按钮
  const handleAppleLoginClick = React.useCallback(
    (e) => {
      if (state_loading) return;
      e.preventDefault();
      e.stopPropagation();
      const el = appleButtonContainerRef.current?.querySelector("#appleid-signin");
      if (el) {
        const clickable = el.querySelector("iframe") || el.firstElementChild;
        if (clickable) clickable.click();
      } else {
        message.error(intl.formatMessage({ id: "register.appleLoginFailed" }) ?? "Apple login failed");
      }
    },
    [state_loading, intl]
  );

  const verify = () => {
    let isOK = true;
    if (state_type === "email") {
      const status = verify_email(true);
      !status.isOK && (isOK = false);
    } else if (state_type === "mobile") {
      const status = verify_mobile(true);
      !status.isOK && (isOK = false);
    } else if (state_type === "subAccount") {
      const status = verifyUserName(true);
      !status.isOK && (isOK = false);
    }
    const status = verify_password(true);
    !status.isOK && (isOK = false);

    return isOK;
  };
  const handleSubmit = () => {
    if (state_loading) return;
    if (!verify()) return;
    geetestRef.current.verify();
  };
  const geetestRef = React.useRef();
  const handleGeetestSuccess = async (puzzleValidateString) => {
    console.log(puzzleValidateString, "puzzleValidateString");
    setState_loading(true);

    /*
    const passwdPublicKey = await axios.asyncAwait(put_publicKey, {
      errorPop: true,
    });

    const faBeforeCheckRet = await axios.asyncAwait(put_authorizeFaBeforeCheck, {
      data: {
        accountLevel: state_type === "subAccount" ? 2 : 1,
        countryCode: state_countryCode,
        loginPwd: doRsaEncrypt(passwdPublicKey.data.publicKey, state_password),
        puzzleValidateString,
        userName: (() => {
          const obj = {
            "email": state_email,
            "mobile": state_mobile,
            "subAccount": userName,
          }
          return obj[state_type];
        })()
      },
      errorPop: true,
    });
    if (faBeforeCheckRet.err) return setState_loading(false);
    if (!faBeforeCheckRet.data.validNumber) {
      const faRet = await axios.asyncAwait(post_authorizeFa, {
        data: {
          faId: faBeforeCheckRet.data.faId,
        },
        errorPop: true,
      });
      setState_loading(false);
      if (!faRet.err) {
        cookie.set("token", faRet.data.accessToken);
        redirectToHome(router);
        // redirectBackUrl(router); // 原逻辑：按 backurl 跳转，需恢复时可改回
      }

      return;
    }

    setState_loading(false);
    sessionStorage.set("2fa_new", faBeforeCheckRet.data);
    sessionStorage.set("puzzleValidateString", puzzleValidateString);

    const isSubAccount = state_type === "subAccount";
    if (typeof location !== "undefined")
      return (location.href = getAbsoluteUrl({
        pathname: "/login/2fa",
        locale: router.locale,
        query: isSubAccount ? { ...router.query, isSubAccount } : router.query,
      }));
     */

    let deviceId = "";
    if (LocalStorage.get("client-device-id")) {
      deviceId = LocalStorage.get("client-device-id");
    } else {
      deviceId = getUUID();
      LocalStorage.set("client-device-id", deviceId);
    }

    const passwdPublicKey = await axios.asyncAwait(post_passwdPublicKey, {
      errorPop: true,
    });
    if (passwdPublicKey.err) return setState_loading(false);

    const send = {
      userName: state_type === "email" ? state_email : state_mobile,
      countryCode: state_type === "email" ? undefined : state_countryCode,
      loginPwd: doRsaEncrypt(passwdPublicKey.data.publicKey, state_password),
      passwdId: passwdPublicKey.data.passwdId,
      puzzleValidateString,
      regChannel: "xt",
      version: "2.0",
    };

    const loginCheck =
      state_type === "subAccount"
        ? post_subAccountloginByFaBeforeCheck
        : post_loginByFaBeforeCheck;

    const sendData =
      state_type === "subAccount"
        ? {
            accountName: userName,
            loginPwd: doRsaEncrypt(
              passwdPublicKey.data.publicKey,
              state_password
            ),
            passwdId: passwdPublicKey.data.passwdId,
            puzzleValidateString,
            regChannel: "xt",
          }
        : send;

    const { err, data } = await axios.asyncAwait(loginCheck, {
      headers: {
        "client-device-id": doRsaEncrypt(
          passwdPublicKey.data.publicKey,
          deviceId
        ),
        "client-device-name": `${getExplore()} (${browserRedirect()})`,
      },
      data: sendData,
      errorPop: true,
      // successPop: true,
    });
    setState_loading(false);
    if (err) return;

    try {
      sensors.track("LoginButtonClick", {
        login_method:
          state_type === "email"
            ? "邮箱"
            : state_type === "subAccount"
            ? "子账户"
            : "手机",
      });
    } catch (error) {}
    const isSubAccount = state_type === "subAccount";
    sessionStorage.set("2fa", data);
    sessionStorage.set("puzzleValidateString", puzzleValidateString);
    //登陆是0，重置密码是13
    const newData = sessionStorage.get("2fa");
    if (
      isSubAccount &&
      newData &&
      newData.faCheckId &&
      !newData.faItems?.length
    ) {
      // 子账号登录不需要进入验证页面
      const params = {
        faCheckId: newData.faCheckId,
        faBizType: 0,
      };
      const resData = await axios.asyncAwait(get_faCheckToken, {
        params,
        errorPop: 0,
      });
      const { err, data } = await axios.asyncAwait(
        get_subAccountloginBy2Fa,
        resData.data.faResultId,
        {
          errorPop: true,
        }
      );
      console.log(err, data, 44444);
      if (err) return;
      loginSuccessAndSkip(data, router);
      return;
    }
    if (typeof location !== "undefined")
      return (location.href = getAbsoluteUrl({
        pathname: "/login/2fa",
        locale: router.locale,
        query: isSubAccount ? { ...router.query, isSubAccount } : router.query,
      }));
    // if (data.faItems.length) {
    router.push({
      pathname: "/login/2fa",
      query: isSubAccount ? { ...router.query, isSubAccount } : router.query,
    });
    return;
    // }
    // const { err, data } = await axios.asyncAwait(
    //   isSubAccount ? get_subAccountloginBy2Fa : get_loginBy2Fa,
    //   faResultId,
    //   {
    //     errorPop: true,
    //   }
    // );
  };

  const registerHref = getAbsoluteUrl({
    pathname: "/register",
    locale: router.locale,
    query: router.query,
  });

  return (
    <AuthShell>
      <div className={cx(stylesLess.main, isDark ? "dark" : "light", isSpikexPc && stylesLess.spikexPc)}>
        <Script src={GSI_SCRIPT_SRC} strategy="afterInteractive" onLoad={() => setGsiReady(true)} />
        <Script src={APPLE_SCRIPT_SRC} strategy="afterInteractive" onLoad={() => setAppleAuthReady(true)} />
        <div className="left">
          <h1 className="iHead">
            {isSpikexPc ? (
              <FormattedMessage id="app.login" />
            ) : (
              <FormattedMessage id="app.welcomeToXT" />
            )}
          </h1>
          {isSpikexPc && (
            <p className="iSubhead">
              <FormattedMessage
                id="login.isRegister"
                values={{
                  0: (
                    <a href={registerHref} className="iSubLink">
                      <FormattedMessage id="login.registerNow" />
                    </a>
                  ),
                }}
              />
            </p>
          )}

          <div className={"iForm"}>
            <div className="iNav">
              <button
                className={`btntxt loginBtn ${isDark ? "dark" : "light"} ${
                  state_type === "email" ? "atv" : ""
                }`}
                disabled={state_loading}
                onClick={() => setState_type("email")}
              >
                <FormattedMessage id="app.email" />
              </button>
              <button
                className={`btntxt loginBtn ${isDark ? "dark" : "light"} ${
                  state_type === "mobile" ? "atv" : ""
                }`}
                disabled={state_loading}
                onClick={() => setState_type("mobile")}
              >
                <FormattedMessage id="app.mobile" />
              </button>
              {/*<button*/}
              {/*  className={`btntxt loginBtn ${isDark ? "dark" : "light"} ${*/}
              {/*    state_type === "subAccount" ? "atv" : ""*/}
              {/*  }`}*/}
              {/*  disabled={state_loading}*/}
              {/*  onClick={() => setState_type("subAccount")}*/}
              {/*>*/}
              {/*  <FormattedMessage id="app.subAccount" />*/}
              {/*</button>*/}
            </div>

            {state_type === "email" && (
              <FormItem
                title={<FormattedMessage id="app.email" />}
                errMsg={state_email_status.errMsg}
              >
                <FormItemInput
                  autoComplete={"on"}
                  isErr={!!state_email_status.errMsg}
                  placeholder={
                    isSpikexPc
                      ? intl.formatMessage({ id: "auth.emailPlaceholder" })
                      : undefined
                  }
                  prefix={isSpikexPc ? <IconMail /> : undefined}
                  disabled={state_loading}
                  value={state_email}
                  onInput={setState_email}
                  onBlur={() => verify_email(1)}
                />
              </FormItem>
            )}
            {state_type === "mobile" && (
              <FormItem
                title={<FormattedMessage id="app.mobile" />}
                errMsg={state_mobile_status.errMsg}
              >
                <div className={"iMobileDiv"}>
                  <CountryList
                    disabled={state_loading}
                    selectItem={(obj) => setState_countryCode(obj.code || obj.countryCode)}
                    countryQuery="ALL" //REG: 注册场景 , MOBILE: 手机, ALL:所有
                    showType="Small" //Large:大显示框， Small:小显示框
                  />
                  <FormItemInput
                    autoComplete={"on"}
                    isErr={!!state_mobile_status.errMsg}
                    type="tel"
                    inputMode="numeric"
                    placeholder={
                      isSpikexPc
                        ? intl.formatMessage({ id: "auth.mobilePlaceholder" })
                        : undefined
                    }
                    disabled={state_loading}
                    value={state_mobile}
                    onInput={handleInputMobile}
                    onBlur={() => verify_mobile(1)}
                  />
                </div>
              </FormItem>
            )}
            {state_type === "subAccount" && (
              <FormItem
                title={<FormattedMessage id="app.userName" />}
                errMsg={userNameStatus.errMsg}
              >
                <FormItemInput
                  autoComplete={"on"}
                  isErr={!!userNameStatus.errMsg}
                  disabled={state_loading}
                  value={userName}
                  onInput={setUserName}
                  onBlur={() => verifyUserName(1)}
                />
              </FormItem>
            )}

            <FormItem
              title={<FormattedMessage id="app.password" />}
              errMsg={state_password_status.errMsg}
              style={{ marginBottom: 0 }}
            >
              <FormItemPassword
                placeholder={
                  isSpikexPc
                    ? intl.formatMessage({ id: "auth.passwordPlaceholderLogin" })
                    : undefined
                }
                isErr={!!state_password_status.errMsg}
                popover={false}
                allowSpace={true}
                disabled={state_loading}
                value={state_password}
                onInput={setState_password}
                onBlur={() => verify_password(1)}
                onKeyPress={(e) => e.key === "Enter" && handleSubmit()}
              />
            </FormItem>

            <div className={"iLink"}>
              {/*<Link href={{ pathname: "/reset-password" }}>*/}
              {state_type !== "subAccount" && (
                <a
                  href={getAbsoluteUrl({
                    pathname: "/reset-password",
                    locale: router.locale,
                    // 不带 step，避免从 login?step=2 点忘记密码又进 reset-password?step=2 形成循环
                    query: Object.fromEntries(Object.entries(router.query || {}).filter(([k]) => k !== "step")),
                  })}
                >
                  <FormattedMessage id="login.forgotPwd" />
                </a>
              )}
              {/*</Link>*/}
            </div>

            <Geetest ref={geetestRef} onSuccess={handleGeetestSuccess} />

            <ButtonBig
              onClick={handleSubmit}
              style={{ width: "100%", marginTop: isSpikexPc ? "16px" : "24px" }}
              loading={state_loading}
            >
              <FormattedMessage id="app.login" />
            </ButtonBig>

            <div className={"iTip"}>
              <a
                href={registerHref}
                onClick={() => {
                  trackRegisterEntryClick({
                    entry: ENTRIES.LOGIN_PAGE,
                    pagePath: router.asPath || "/accounts/login",
                    pageKey: PAGE_KEYS.LOGIN_MAIN,
                  });
                }}
              >
                <FormattedMessage id="signUpXtAcc" />
              </a>
            </div>

            <div className="socialOr">
              <FormattedMessage id="auth.orContinueWith" />
            </div>

            <div className={stylesLess.socialRow}>
              <div className={stylesLess.socialSlot}>
                <button
                  type="button"
                  className={`${stylesLess.socialBtn} ${isDark ? "dark" : "light"}`}
                  disabled={state_loading || !gsiReady}
                  style={{ pointerEvents: gsiReady ? "none" : "auto" }}
                  tabIndex={gsiReady ? -1 : 0}
                  aria-hidden={gsiReady}
                >
                  <img src={iconGoogle} alt="Google" className={stylesLess.socialIcon} />
                  <FormattedMessage id="register.continueWithGoogle" />
                </button>
                <div
                  className={stylesLess.socialOverlay}
                  ref={googleButtonRef}
                  style={{ pointerEvents: gsiReady ? "auto" : "none" }}
                  aria-hidden="true"
                />
              </div>
              <div className={stylesLess.socialSlot}>
                <button
                  type="button"
                  className={`${stylesLess.socialBtn} ${isDark ? "dark" : "light"}`}
                  disabled={state_loading}
                  style={{ pointerEvents: appleAuthReady ? "none" : "auto" }}
                  tabIndex={appleAuthReady ? -1 : 0}
                  aria-hidden={appleAuthReady}
                  onClick={appleAuthReady ? undefined : handleAppleLoginClick}
                >
                  <img src={isDark ? iconAppleDark : iconAppleLight} alt="Apple" className={stylesLess.socialIcon} />
                  <FormattedMessage id="register.continueWithApple" />
                </button>
                <div
                  ref={appleButtonContainerRef}
                  className={stylesLess.socialOverlay}
                  style={{ pointerEvents: appleAuthReady ? "auto" : "none" }}
                  aria-hidden="true"
                >
                  <div
                    id="appleid-signin"
                    data-color="black"
                    data-border="true"
                    data-type="sign-in"
                    data-border-radius="8"
                    style={{ width: "100%", height: "100%" }}
                  />
                </div>
              </div>
            </div>

            {/* <CaptchaDemo /> */}
          </div>
        </div>
      {/* <div className="right">
      {qrUrl && (
        <>
          {status != "scanSuccess" && (
            <div className="sao">
              <div className="sao_title">
                <FormattedMessage id="app.sao" />
              </div>
              <div className="qr">
                <div className="qr_content">
                  <div className="code">
                    <QRCode
                      value={qrUrl} //value参数为生成二维码的链接
                      size={156} //二维码的宽高尺寸
                      fgColor="#000000" //二维码的颜色
                      imageSettings={{
                        // 配置二维码中间出现的logo信息
                        // src: "data:image/png;base64,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", // logo的地址 可以是在线图片也可以是本地图片 没有默认值 类型为string
                        width: 40, // logo的宽度 默认值是整个二维码的10% 类型为number
                        height: 40, // logo的高度 默认值是整个二维码的10% 类型为number
                        excavate: false, // 是否是镂空状态 默认值false 类型为boolean
                      }}
                    />
                  </div>
                  {status == "EXPIRED" && (
                    <div className="expiration">
                      <div className="expiration_text">
                        <FormattedMessage id="app.expiration" />
                      </div>
                      <div onClick={create_key} className="expiration_button">
                        <FormattedMessage id="app.refresh" />
                      </div>
                    </div>
                  )}
                </div>
                <img src={imgLogo} alt="mobile" />
              </div>
              <div className="sao_text">
                <FormattedMessage id="app.open1" />
              </div>
              <div className="sao_text">
                <FormattedMessage id="app.saoTip" />
              </div>
            </div>
          )}

          {status == "scanSuccess" && (
            <div className="sao_success">
              <img src={correct} alt="correct" />
              <div className="sao_success_title">
                <FormattedMessage id="app.success" />
              </div>
              <div className="sao_success_tip">
                <FormattedMessage id="app.sure" />
              </div>
            </div>
          )}
        </>
      )}
      </div> */}
      </div>
    </AuthShell>
  );
})
